import { type FC, type HTMLAttributes } from 'react'
import { useTheme } from '@mui/material/styles'

import { type LoaderSize } from './Loader.types'
import * as styles from './styles'

export type LoaderProps = {
  size?: LoaderSize
}

const Loader: FC<LoaderProps & HTMLAttributes<HTMLDivElement>> = ({ size = 24, ...rest }) => {
  const theme = useTheme()

  return (
    <div {...rest} css={styles.loader(size)}>
      <div css={styles.circle1(theme)} />
      <div css={styles.circle2(theme)} />
      <div css={styles.circle3(theme)} />
      <div css={styles.circle4(theme)} />
    </div>
  )
}
export default Loader
